import { useRef, type FC } from 'react'
import classNames from 'classnames'
import { Checkbox, type IDropdownItemProps, Icon, Tooltip, Typography } from 'shared/ui'
import { useIsElementTruncated } from 'shared/hooks'
import styles from './styles.module.scss'

export const DropdownCardCheckbox: FC<IDropdownItemProps> = ({
  item,
  onChange,
  onChangeCheckbox,
}) => {
  const titleRef = useRef<HTMLElement>(null)
  const isLabelTruncated = useIsElementTruncated(titleRef, [item.label, item.labelContent])

  const isCardClick = item.isCardClick
  const onCardClick = () => {
    if (isCardClick) {
      onChange?.(item)
    }
  }

  const labelWidth = item.labelWidth === '100%' ? 'calc(100% - 24px)' : item.labelWidth

  const content = (
    <div className={styles.contentWrapper}>
      <Checkbox
        size={16}
        disabled={item.disabled}
        checked={!!item.activeValue}
        onChange={(value) => {
          !isCardClick && onChange?.(item)
          onChangeCheckbox?.(value, item)
        }}
      />
      {(item.iconL || item.customIconL) && (
        <div
          className={classNames(styles.icon, item.customFields?.iconClassName)}
          style={{ color: (item.customFields?.leftIconColor as string) || 'inherit' }}
        >
          {item.iconL ? <Icon icon={item.iconL} /> : item.customIconL}
        </div>
      )}
      <div className={styles.checkboxLabel} style={{ width: labelWidth }}>
        <Typography ellipsis variant={'body-md-regular'} ariaLabel={'label'} ref={titleRef}>
          {item.labelContent || item.label}
        </Typography>

        {!!item.labelCount && (
          <Typography
            variant={'body-xs-medium'}
            color={'var(--content-neutral-primary)'}
            ariaLabel={'labelCount'}
            className={styles.labelCount}
          >
            {item.labelCount}
          </Typography>
        )}
      </div>
    </div>
  )

  return (
    <div
      className={classNames(
        styles.checkboxItemContainer,
        item.disabled && styles.disabledCheckBox,
        !item.disabled && isCardClick && styles.pointer
      )}
      onClick={onCardClick}
    >
      {item.tooltipProps || isLabelTruncated ? (
        <Tooltip fullWidth placement='left' label={item.label} {...item.tooltipProps}>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </div>
  )
}
